import React from "react";

export default function Name({
  elem,
  nameVisited,
  data,
  setNameVisited,
  setData,
  messageError,
}) {
  return (
    <div className="mb-2">
      <label for="comentario">
        {elem.label}
        <span className="obligatory"> *</span>
      </label>
      <input
        type="text"
        className={`${
          nameVisited ? (data?.name ? "" : "formError") : ""
        } form-control input-sm textInput especialGroup formHover`}
        name={elem.id}
        onClick={() => setNameVisited(true)}
        onChange={(e) =>
          setData({
            ...data,
            name: e.target.value,
          })
        }
        id={elem.id}
        placeholder={elem.placeholder}
        value={data?.name}
      />
      {nameVisited && !data?.name ? (
        <span className="errorMessage">{data?.name ? "" : messageError}</span>
      ) : (
        <span></span>
      )}
    </div>
  );
}
